import { forOwn } from '../../../lib/utilities';
import API from '../../API/api';
import FilterOptionsConstants from '../../_flux/constants/filter_options_contants';

function requestRegoLookup(filters) {
    const queryString = 'licencePlate=' + filters['registration'] + '&state=' + filters['state'];
    return API.GET({
        apiPath: '/api/v2/vehicle/licenceplate/?' + queryString
    }).done(response => {
        forOwn(response, filterOptions => {
            if (filterOptions.length > 0
                &&  filterOptions[0][FilterOptionsConstants.OPTION_VALUE] === '') {
                filterOptions.shift();
            }
        });

        return response;
    });
}

export { requestRegoLookup };
